module.exports = __webpack_public_path__ + "assets/merriweather-italic.b64c869d244520a87499723c2c9f303f.woff2";